import { render, staticRenderFns } from "./FuelChargesStaffStats.vue?vue&type=template&id=e4dcc80a&"
import script from "./FuelChargesStaffStats.vue?vue&type=script&lang=js&"
export * from "./FuelChargesStaffStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports